<template>
    <div class="area-content-body admin-permissiondefinitions-contain">
        <DxDataGrid class="admin-permissiondefinitions-grid"
                    :focused-row-enabled="true"
                    key-expr="_id"
                    :data-source="permissionDefinitions"
                    v-model:selectedRowKeys="selectedPermissionDefinition"
                    @selection-changed="selectionChanged">
            <DxColumn data-field="key" caption="Key" />
            <DxColumn data-field="label" caption="Bezeichnung" />
            <DxColumn data-field="area" caption="Bereich" />
            <DxSelection mode="single" />
        </DxDataGrid>

        <router-view @saved="fetchData"></router-view>
    </div>
</template>

<script lang="js">
    import { defineComponent } from 'vue';
    import DxDataGrid, {
        DxColumn,
        DxSelection
    } from 'devextreme-vue/data-grid';
    import permissionDefinitionApi from '../services/PermissionApi';

    export default defineComponent({
        components: {
            DxDataGrid,
            DxColumn,
            DxSelection
        },
        data() {
            return {
                permissionDefinitions: [],
                selectedPermissionDefinition: []
            };
        },
        async created() {
            await this.fetchData();

            if (!this.$route.params?.id) {
                this.$router.replace('/Admin/PermissionDefinitions/new');
            }
        },
        watch: {
            '$route.params.id': {
                immediate: true,
                handler(id) {
                    if (!id || id === 'new') {
                        this.selectedPermissionDefinition = [];
                    } else {
                        this.selectedPermissionDefinition = [id];
                    }
                }
            }
        },
        methods: {
            async fetchData() {
                this.permissionDefinitions = (await permissionDefinitionApi.getAll()).sort((a, b) =>
                    (a.Area || '').localeCompare(b.Area || '') ||
                    (a.Group || '').localeCompare(b.Group || '') ||
                    ((a.SortOrder || 0) - (b.SortOrder || 0)) ||
                    (a.Key || '').localeCompare(b.Key || '')
                );
            },
            selectionChanged(e) {
                const id = e.selectedRowKeys?.[0];
                if (id)
                    this.$router.push('/Admin/PermissionDefinitions/' + id);
            }
        }
    });
</script>

<style>
    .admin-permissiondefinitions-contain {
        display: grid;
        grid-template-columns: 1fr 3fr;
        grid-gap: 10px;
        grid-template-rows: minmax(0, 1fr);
    }

    .admin-permissiondefinitions-grid .dx-datagrid {
        padding: 10px;
        background-color: #2a2a2a;
    }
</style>